import { FC, memo, useMemo } from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { FilterGroupInputsProps } from '../..'

type CitizenFilterWithKey = any & {
  [key: string]: string
}

type Props = {
  fields: FilterGroupInputsProps[]
  values: CitizenFilterWithKey
}

const FilterTexts: FC<Props> = ({ fields, values }) => {
  function setFormatedValueOnInput(field: FilterGroupInputsProps) {
    const { type, name, mask } = field
    let fieldValue = values[name]
    if (!fieldValue) return null
    if (type === 'MASKED_INPUT' && mask) fieldValue = mask(fieldValue)
    return fieldValue
  }

  const fieldThatValueIsNotEmpty = useMemo(() => {
    return fields.filter((field) => {
      const value = setFormatedValueOnInput(field)
      return !!value
    })
  }, [])

  return (
    <Flex direction="column" gap={1} mt={fieldThatValueIsNotEmpty.length === 0 ? 0 : 4}>
      {fieldThatValueIsNotEmpty.map((field) => {
        let value = setFormatedValueOnInput(field)
        if (field.formatValue) value = field.formatValue(value)
        return (
          <Flex key={field.label} align="center" gap={2}>
            <Text>{field.label}: </Text>
            <Text color="primary">{value}</Text>
          </Flex>
        )
      })}
    </Flex>
  )
}

export default memo(FilterTexts)
